import { IconTextComponentItem } from '@varo/graphql-schema-types';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { IconAvatarProps } from 'shared/components/vxl/avatar/IconAvatar/IconAvatar';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

type IconTextComponentCellProps = {
  iconTextItems: IconTextComponentItem[];
};

const IconTextComponentCell = ({
  iconTextItems,
}: IconTextComponentCellProps) => {
  return (
    <>
      {iconTextItems.map((item, index) => (
        <View key={item.id}>
          <ListItem
            primaryCopy={item?.copy}
            leadingAccessory={{
              id: item.id,
              name: VXLComponentId.ICON_AVATAR,
              props: {
                variant: 'MD',
                iconKey: item.icon?.iconKey,
              } as IconAvatarProps,
            }}
            primaryNumberOfLines={0}
            showsChevron={false}
          />
          <View style={styles.dividerStyle}>
            {index !== iconTextItems.length - 1 ? <HairLineDivider /> : null}
          </View>
        </View>
      ))}
    </>
  );
};

const styles = StyleSheet.create({
  dividerStyle: { paddingHorizontal: theme.spacing.m },
});

export default IconTextComponentCell;
